import { Component, OnInit } from '@angular/core';
import { MissingWorkEntry, StateService, ToolService } from '../../public-api';
import { ModalController } from '@ionic/angular';
import { ModalRole } from '../models/modal-roles';

@Component({
  selector: 'lib-missing-work-entry',
  templateUrl: './missing-work-entry.component.html',
  styleUrls: ['./missing-work-entry.component.scss'],
  standalone: false,
})
export class MissingWorkEntryComponent implements OnInit {
  entries: MissingWorkEntry[] = [];
  selectedIds = new Set<string>();
  allSelected: boolean = false;

  constructor(
    public state: StateService,
    private modalCtrl: ModalController,
    public tools: ToolService
  ) {}

  ngOnInit() {
    this.state.missingWorkEntries$.subscribe((x) => (this.entries = x));
  }

  // Einzel-Auswahl
  toggleSelection(id: string, checked: boolean) {
    if (checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }
    this.allSelected = this.selectedIds.size == this.entries.length;
  }

  isSelected(id: string): boolean {
    return this.selectedIds.has(id);
  }

  toggleAll(checked: boolean) {
    if (checked) {
      this.entries.forEach((u) => this.selectedIds.add(u.id));
    } else {
      this.selectedIds.clear();
    }
  }

  async delete() {
    await this.state.deleteMissingWorkEntries(Array.from(this.selectedIds));
    this.allSelected = false;
    this.selectedIds.clear();
  }

  close() {
    this.modalCtrl.dismiss(null, ModalRole.Cancel);
  }
}
